// extracted by mini-css-extract-plugin
module.exports = {"button":"button-1xP_L"};